import axios from 'axios'
import { getEnviron } from '../../services/utils'

import Config from '../../features/config.json'

class ApiAbstract {
    static url = `${Config[getEnviron()]?.endpoint?.protocol ?? 'https'}://${Config[getEnviron()]?.endpoint?.api ?? 'localhost'}`
    static mockerUrl = `${Config[getEnviron()]?.mocker?.protocol}://${Config[getEnviron()]?.mocker?.api}`

    static getUrl(uri, useMocker = false) {
        if (useMocker) return `${this.mockerUrl}${this.baseUri}${uri}`
        if (this.baseEndpoint) return `${this.baseEndpoint}${this.baseUri}${uri}`
        return `${this.url}${this.baseUri}${uri}`
    }

    static getProcess(api=``, callback={success:null, error:null, except:null}, execCallback=true, okStatus=200, useMocker = false) {
        callback = callback || {success:null, error:null, except:null}
        return axios.get(
            this.getUrl(api, useMocker))
            .then(result => { return checkResult(result, callback, execCallback, okStatus) })
            .catch(e => { return catchError(e, callback, execCallback) })
    }

    static postProcess(api=``, data={}, callback={success:null, error:null, except:null}, execCallback=true, okStatus=201, useMocker = false) {
        callback = callback || {success:null, error:null, except:null}
        return axios.post(
            this.getUrl(api, useMocker), data)
            .then(result => { return checkResult(result, callback, execCallback, okStatus) })
            .catch(e => { return catchError(e, callback, execCallback) })
    }

    static putProcess(api=``, data={}, callback={success:null, error:null, except:null}, execCallback=true, okStatus=200, useMocker = false) {
        callback = callback || {success:null, error:null, except:null}
        return axios.put(
            this.getUrl(api, useMocker), data)
            .then(result => { return checkResult(result, callback, execCallback, okStatus) })
            .catch(e => { return catchError(e, callback, execCallback) })
    }

    static patchProcess(api=``, data={}, callback={success:null, error:null, except:null}, execCallback=true, okStatus=200, useMocker = false) {
        callback = callback || {success:null, error:null, except:null}
        return axios.patch(
            this.getUrl(api, useMocker), data)
            .then(result => { return checkResult(result, callback, execCallback, okStatus) })
            .catch(e => { return catchError(e, callback, execCallback) })
    }

    static deleteProcess(api=``, callback={success:null, error:null, except:null}, execCallback=true, okStatus=200, useMocker = false) {
        callback = callback || {success:null, error:null, except:null}
        return axios.delete(
            this.getUrl(api, useMocker))
            .then(result => { return checkResult(result, callback, execCallback, okStatus) })
            .catch(e => { return catchError(e, callback, execCallback) })
    }
}

function checkResult(result, callback, execCallback, okStatus) {
    if (result.status === okStatus) {
        const res = {except: false, error: false, data:result.data, callback:callback}

        if (execCallback && callback.success && (typeof(callback.success) === 'function'))
            callback.success(res)

        return res
    }

    const res = {error: true, data:result, callback:callback}

    if (execCallback && callback.error && (typeof(callback.error) === 'function'))
        callback.error(res)

    return res
}

function catchError(e, callback, execCallback) {
    const res = {except: true, data:e, callback:callback}

    if (execCallback && callback.error && (typeof(callback.error) === 'function'))
        callback.error(res)

    return res
}

export default ApiAbstract
